import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import NavigationBar from "./components/Navbar";
import Welcome from "./components/Welcome";
import Services from "./components/Services";
import Process from "./components/Process";
import Contact from "./components/Contact";
import AboutUs from "./components/AboutUs";
import Footer from "./components/Footer";

// Component to handle hash and unknown routes
function RedirectToHome() {
  const location = useLocation();

  useEffect(() => {
    // Check if URL has hash or unknown path
    if (location.hash || location.pathname !== "/") {
      window.history.replaceState(null, "", "/"); // Replace URL with homepage
    }
  }, [location]);

  return <Navigate to="/" replace />;
}

function App() {
  return (
    <Router>
      <NavigationBar />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Welcome />
              <Services />
              <Process />
              <Contact />
            </>
          }
        />
        <Route path="/about" element={<AboutUs />} />

        {/* Catch-all: Wrong URLs or hash redirect to homepage */}
        <Route path="*" element={<RedirectToHome />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
